export default __webpack_public_path__ + "static/Sohne-BuchKursiv-be8f7c0f7b54e3986dcc1c7894d392df.woff2";